import { styled } from '@mui/system'
import { Grid, Box } from '@mui/material'

export const Wrapper = styled(Grid)(`
    display:flex;
    gap: 16px;
    & Table {
        border-radius: 4px;
    }
`)

export const InnerWrapper = styled(Box)(`
    width: 100%;
    display:flex;
    flex-direction:column;
    gap: 16px;
`)
